import { createAction } from '@reduxjs/toolkit';
import { saveToLocalStorage } from '@/lib/helpers';

/**
 * @typedef {{ tableName: string, newConfig: Object }} SetTableConfigPayload
 */
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<SetTableConfigPayload>} */
export const setTableConfig = createAction('table-configs/set');
export const _setTableConfig = (tableName, updateData) => (dispatch, getState) => {
  const currentState = getState();
  const { tableConfigs } = currentState;
  const currentConfig = tableConfigs[tableName];
  const newConfig = {
    ...currentConfig,
    ...updateData,
  };

  saveToLocalStorage('tableConfigs', {
    ...tableConfigs,
    [tableName]: newConfig,
  });

  return dispatch(setTableConfig({ tableName, newConfig }));
};
